import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const Login = () => {
  const location = useLocation();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const payload = {
        email: (formData.email || '').trim(),
        password: formData.password || ''
      };
      const response = await fetch('/api/accounts/login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const text = await response.text();
      let data = {};
      try { data = JSON.parse(text); } catch (e) { /* сервер вернул HTML */ }

      if (response.ok) {
        // Сохраняем токены и пользователя. Полные права подтянем позже из API.
        if (data?.tokens?.access) localStorage.setItem('access_token', data.tokens.access);
        if (data?.tokens?.refresh) localStorage.setItem('refresh_token', data.tokens.refresh);
        if (data?.user) localStorage.setItem('user', JSON.stringify(data.user));
        // Возврат туда, откуда пришли, иначе на корень
        const to = (location.state && location.state.from?.pathname) || '/';
        window.location.replace(to);
      } else {
        setError(data.detail || data.non_field_errors?.[0] || 'Ошибка входа');
      }
    } catch (error) {
      console.error('Ошибка входа:', error);
      setError('Ошибка подключения к серверу');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8">
        {/* Логотип и заголовок */}
        <div className="text-center">
          <div className="mx-auto h-20 w-20 gradient-primary rounded-2xl flex items-center justify-center mb-6 shadow-glow">
            <svg className="h-10 w-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">PWA Menu</h2>
          <p className="text-gray-600">Вход в админ панель</p>
        </div>

        {/* Форма входа */}
        <div className="card shadow-strong">
          <form className="space-y-6" onSubmit={handleSubmit}>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="input-field"
                placeholder="Введите email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Пароль
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="input-field"
                placeholder="Введите пароль"
                value={formData.password}
                onChange={handleChange}
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full btn-primary py-3 text-base font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                    Вход...
                  </div>
                ) : (
                  'Войти'
                )}
              </button>
            </div>
          </form>
        </div>

        {/* Дополнительная информация */}
        <div className="text-center">
          <p className="text-sm text-gray-500">
            Только для администраторов и сотрудников
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login; 